<template>
    <TournamentCenterEntrance v-if="isTournamentCenterEntranceEnabled" />
    <BetBuilderCombinations
        v-if="isBetBuilderCombinationsEnabled"
        v-bind:recommendations="betBuilderRecommendations"
        v-bind:isLoaded="isLoaded"
        storageKey="betBuilderExpanded"
    >
        <template #default="{ combination, order }">
            <BetBuilderCombination
                v-bind:combination="combination"
                v-bind:order="order"
            />
        </template>
    </BetBuilderCombinations>
    <MpCombinations v-if="isMpCombinationsEnabled" />
</template>

<script lang="ts" setup>
    import { toRefs } from '@vueuse/core';
    import { storeToRefs } from 'pinia';
    import BetBuilderCombination from '@/components/recommendations/BetBuilderCombination.vue';
    import BetBuilderCombinations from '@/components/recommendations/BetBuilderCombinations.vue';
    import MpCombinations from '@/components/recommendations/MpCombinations.vue';
    import TournamentCenterEntrance from '@/components/tournamentCenter/entrance/TournamentCenterEntrance.vue';
    import { MarketPage } from '@/interface/enum';
    import { useFeaturedVisibility } from '@/libraries/composables/useFeaturedVisibility';
    import { useBetBuilderRecommendations } from '@/libraries/recommendation/useBetBuilderRecommendations';
    import { useFeatureToggleStore } from '@/stores/featureToggleStore';
    import { useRootStore } from '@/stores/rootStore';

    const props = defineProps({
        haveEvent: {
            type: Boolean,
            required: true,
        },
    });

    const { haveEvent } = toRefs(props);

    const {
        isTournamentCenterEntranceEnabled,
        isBetBuilderCombinationsEnabled,
        isMpCombinationsEnabled,
    } = useFeaturedVisibility(haveEvent);

    const { marketPage } = storeToRefs(useRootStore());
    const { betBuilderCombinationDisplayRule } = storeToRefs(useFeatureToggleStore());

    const { betBuilderRecommendations, isLoaded } = useBetBuilderRecommendations(
        {
            isLivePage: marketPage.value === MarketPage.Live,
            preBuiltSelectionDisplay: betBuilderCombinationDisplayRule.value,
        },
        isBetBuilderCombinationsEnabled,
    );
</script>
